import React, { useEffect, useState } from 'react';
import './Cashmanagment.css';
import Graph7 from '../components/Graph7';
import Fichearticle from './Fichearticle';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://demo.myssa.net/api';

/* ─── Clés réelles en base ─── */
const MONTH_KEYS = ['M','M+1','M+2','M+3','M+4','M+5','M+6','M+7','M+8','M+9','M+10','M+11'];

/* ─── Génère le mapping clé → label lisible (ex: "Juin 2026") ─── */
const getMonthLabels = () => {
  const now = new Date();
  const labels = {};
  MONTH_KEYS.forEach((key, i) => {
    const d = new Date(now.getFullYear(), now.getMonth() + i, 1);
    const raw = d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
    labels[key] = raw.charAt(0).toUpperCase() + raw.slice(1);
  });
  return labels;
};

const Cashmanagment = () => {
  const [tauxData, setTauxData] = useState(null);
  const [filterColumn, setFilterColumn] = useState(null);
  const [modalItem, setModalItem] = useState(null);

  useEffect(() => {
    document.title = 'MYSSA – Cash managment';
  }, []);

  /* ── Chargement des données stock projeté à l'ouverture de l'onglet ── */
  useEffect(() => {
    fetch(`${API}/evolution_stock`)
      .then((res) => {
        if (!res.ok) throw new Error('Erreur chargement PG');
        return res.json();
      })
      .then((data) => {
        const dataTriee = [...data].sort((a, b) => parseFloat(b.Indice) - parseFloat(a.Indice));
        setTauxData(dataTriee);
        setFilterColumn(null);
      })
      .catch((err) => {
        console.error('Erreur fetch:', err);
        setTauxData(null);
      });
  }, []);

  /* ── Handler clic barre Graph7 → tri du tableau ── */
  const handleBarClick = (monthKey) => {
    setFilterColumn(prev => prev === monthKey ? null : monthKey);
  };

  /* ── Tableau taux de couverture ── */
  const renderTauxTable = () => {
    if (!tauxData || tauxData.length === 0) return null;

    const colonnesFixes = ['Item', 'Déscription'];
    const monthLabels = getMonthLabels();

    let dataAffichee = tauxData;
    if (filterColumn && MONTH_KEYS.includes(filterColumn)) {
      dataAffichee = [...tauxData]
        .sort((a, b) => (parseFloat(b[filterColumn]) || 0) - (parseFloat(a[filterColumn]) || 0));
    }

    return (
      <div className="taux-container">
        <table>
          <thead>
            <tr>
              {/* ★ Largeurs et position des 2 colonnes figées : variables --cm-w-item / --cm-w-desc dans Cashmanagment.css */}
              {colonnesFixes.map((col, i) => (
                <th key={col} className={i === 0 ? 'col-fixe col-item' : 'col-fixe col-desc'}>
                  {col}
                </th>
              ))}
              {MONTH_KEYS.map((key) => (
                <th
                  key={key}
                  onClick={() => handleBarClick(key)}
                  title="Cliquez pour trier de la plus grande à la plus petite valeur"
                  style={{
                    backgroundColor: filterColumn === key ? '#dbeafe' : undefined,
                    color:           filterColumn === key ? '#185FA5' : undefined,
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {monthLabels[key]}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {dataAffichee.map((row, idx) => (
              <tr key={idx}>
                {colonnesFixes.map((col, i) => (
                  <td
                    key={col}
                    className={`col-fixe ${i === 0 ? 'col-item item-link' : 'col-desc'}`}
                    onClick={col === 'Item' ? () => setModalItem(row['Item']) : undefined}
                    title={col === 'Déscription' ? row[col] : undefined}
                  >
                    {row[col]}
                  </td>
                ))}
                {MONTH_KEYS.map((key) => (
                  <td key={key} className="col-mois">
                    {Math.round(parseFloat(row[key]))}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="cadre">

      {/* ══════════════════════════════════════
          MODAL FICHEARTICLE
      ══════════════════════════════════════ */}
      {modalItem && (
        <div className="modal-overlay" onClick={() => setModalItem(null)}>
          <div className="modal-inner" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setModalItem(null)}>
              ✕ Fermer
            </button>
            <Fichearticle itemPrefill={modalItem} />
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════
          GRAPH7 — Taux de couverture (Stock projeté) + tableau
      ══════════════════════════════════════ */}
      {/* ★ Mise en page responsive : graphique et tableau côte à côte sur grand écran,
            l'un sous l'autre sur écran étroit (réglages dans Cashmanagment.css, bloc .cm-layout) */}
      {tauxData && (
        <div className="cm-layout">
          <div className="graph7-container">
            <Graph7
              onBarClick={handleBarClick}
              activeKey={filterColumn}
            />
          </div>
          {renderTauxTable()}
        </div>
      )}

    </div>
  );
};

export default Cashmanagment;